import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DefaultThunkConfig } from '@/app/providers/storeProvider';
import type { TokenData, UserData } from '@/z-shared/lib/types/userData';
import type { AxiosError } from 'axios';
import { cookieHelper, CookieKeyEnum } from '@/app/cookies';
import type { AppAxiosErrorPayload } from '@/z-shared/api';
import type { CaptchaBackendParams } from '../types/captchaBackendParams';

export interface LoginProps extends CaptchaBackendParams {
    email: string;
    password: string;
}

export const login = createAsyncThunk<UserData, LoginProps, DefaultThunkConfig>(
    'auth/login',
    async (authProps, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        const fingerprint = cookieHelper.get(CookieKeyEnum.FINGERPRINT);

        try {
            cookieHelper.update(CookieKeyEnum.USER_DATA, { email: authProps.email });
            const response = await extra.api.post<TokenData>('/auth/login', { ...authProps, fingerprint });
            cookieHelper.update(CookieKeyEnum.USER_DATA, { ...response.data });
            return response.data;
        }
        catch (e) {
            const error = e as AxiosError<AppAxiosErrorPayload>;
            return rejectWithValue(error.response?.data);
        }
    },
);
